const headerData = [
     {
        prop: 'id',
        label: '序号',
        columnwidth: 50,

      },
      {
        prop: 'MFCode',
        label: '编码',
        columnwidth: 150
      },
      {
        prop: 'MFName',
        label: '名称',
        columnwidth: 220
      },
      {
        prop: 'Abbr',
        label: '缩写',
        columnwidth: 150
      },
      {
        prop: 'ShortName',
        label: '简称',
        columnwidth: 150
      },
      {
        prop: 'CreatorName',
        label: '创建人',
        columnwidth: 220
      },
      {
        prop: 'CreateTime',
        label: '创建时间',
        columnwidth: 120
      },
      {
        prop: 'UpdaterName',
        label: '修改人',
        columnwidth: 131
      },
      {
        prop: 'UpdateTime',
        label: '修改时间',
        columnwidth: 170
      },
];
export default headerData;